import { gpCommon } from '../app';
import { ContextMenuItem } from '../util/context-menus';
import { convertMenuItemDefinition } from '#gp/app-common/util/context-menu-lib-items';
import { installContextMenuGestureGuard } from '../util/context-menu-gesture-guard';
//import { ContextMenuItem, RegularMenuItem, Separator, SubMenuItem } from '../util/context-menus';


export const ContextMenuSetupService_ServiceName = 'gpContextMenuSetupService';
export const gpContextMenuSetupService_ServiceName = ContextMenuSetupService_ServiceName;

export interface ContextMenuInstanceReference {
    showMenu(location: { x: number, y: number }): void;
}

export interface gpContextMenuSetupService {
    setupContextMenu(setupOptions: {
        htmlElem: HTMLElement;
        triggerSelector: string;
        getContextMenuItems: (triggerElement: ng.IAugmentedJQuery, pageLocation: { x: number, y: number }) => ContextMenuItem[];
        onShow?: () => void;
    }): ContextMenuInstanceReference;
}

// GH #336: jQuery-contextMenu activates items on mouseup, so in Safari the release of
// the right-click (or Ctrl+click) that opened the menu runs whatever item was painted
// under the pointer. Installed here, once per bundle, rather than per menu: the guard
// is a document-level capture listener keyed on the menu's own class, so it also covers
// the two menus that build their config directly instead of going through this service
// (gantt-tasklist.ts and react-resource-list/resource-list.tsx). See the guard module
// for why this is not a button test and not itemClickEvent.
installContextMenuGestureGuard(document);

class ContextMenuSetupService implements gpContextMenuSetupService {
    static ServiceName: string = ContextMenuSetupService_ServiceName;
    static $inject = [];

    constructor(
    ) {
    }

    setupContextMenu(setupOptions: {
        htmlElem: HTMLElement;
        triggerSelector: string;
        getContextMenuItems: (triggerElement: ng.IAugmentedJQuery, pageLocation: { x: number, y: number }) => ContextMenuItem[];
        onShow?: () => void;
    }): ContextMenuInstanceReference {

        const { htmlElem, triggerSelector, getContextMenuItems } = setupOptions;
        const jqAny: any = $(htmlElem);



        // context menu comes from here
        // https://swisnl.github.io/jQuery-contextMenu/index.html
        const options: JQueryContextMenuOptions = {
            selector: triggerSelector,
            className: 'gp-context-menu',
            zIndex: 1000,
            reposition: false, // set to false to force the menu to be rebuild on every click
            autoHide: false,
            callback: function (key, options) {
                //let m = "clicked: " + key + " on " + $(this).text();
                //if (window.console) {
                //    console.log(m);
                //}
                //else {
                //    alert(m);
                //}
            },
            events: {
                show: function (options) {
                    if (setupOptions.onShow) setupOptions.onShow();
                    jqAny.contextMenu(false);
                    options.trigger = 'none';
                },
                hide: () => {
                    htmlElem.focus();
                },
            },
            build: function ($triggerElement, e) {
                // So entries that open floating UI (e.g. "Ask AI") can anchor
                // at the click point; the menu can also be opened
                // programmatically, with no pointer event to read.
                const pageLocation = {
                    x: (e as any)?.pageX ?? window.innerWidth / 2,
                    y: (e as any)?.pageY ?? window.innerHeight / 2,
                };
                let srcItems = getContextMenuItems($triggerElement, pageLocation);
                let menuItemNumber = 0;

                function getNextId() {
                    ++menuItemNumber;
                    return `${menuItemNumber}`;
                }

                let destItems = convertMenuItemDefinition(srcItems, getNextId);

                return {
                    items: destItems,
                    // we set the trigger to none so that repeated right clicks to not re-show the same menu. We want right clicks to redo selection.
                    trigger: 'none',
                };
            },
        };

        $.contextMenu(options);

        return {
            showMenu: (location) => {
                $(triggerSelector).contextMenu(location)
            }
        }
    }


}

gpCommon.service(ContextMenuSetupService.ServiceName, ContextMenuSetupService);
